import { RootState, store } from '../../index';
import { IDLE_STATUS } from '../../../utils/types/statuses';
import { TSelectOptions } from '../../../components/common/selects/common/types';
import { IEmailTemplate } from '../../../api/base/EmailTemplates/types';

export const checkCanLoadEmailTemplates = (cb: () => void): void => {
  const { emailTemplates } = store.getState();
  if (emailTemplates.status === IDLE_STATUS) {
    cb();
  }
};

export const getEmailTemplatesForSelect = (state: RootState): TSelectOptions =>
  state.emailTemplates.data.map((tmp) => ({
    value: tmp.id,
    label: tmp.title,
    content: tmp.content,
  }));

export const getDefaultEmailTemplate = (
  state: RootState,
): IEmailTemplate | '' =>
  state.emailTemplates.data.find((template) => template.default) || '';
